type CookieConsentCategory = "preferences" | "statistics" | "marketing"

type CookiebotConsent = Record<CookieConsentCategory, boolean>

type CookiebotWindow = Window & {
  __COOKIEBOT_CBID__?: string | null
  Cookiebot?: {
    consent: CookiebotConsent
    hasResponse: boolean
    renew: () => void
  }
}

const consentCategories: CookieConsentCategory[] = [
  "preferences",
  "statistics",
  "marketing",
]

const cookiebotWindow = (): CookiebotWindow | null =>
  typeof window === "undefined" ? null : (window as CookiebotWindow)

const getCookiebotCbid = (): string | null =>
  cookiebotWindow()?.__COOKIEBOT_CBID__ || null

const hasCookieConsent = (category: CookieConsentCategory): boolean =>
  Boolean(cookiebotWindow()?.Cookiebot?.consent?.[category])

const renewCookieConsent = (): void => {
  cookiebotWindow()?.Cookiebot?.renew()
}

const reloadWhenConsentWithdrawn = (): void => {
  const w = cookiebotWindow()

  if (!w || !getCookiebotCbid()) {
    return
  }

  const snapshotConsent = (consent: CookiebotConsent): CookiebotConsent => ({
    preferences: consent.preferences,
    statistics: consent.statistics,
    marketing: consent.marketing,
  })

  let previousConsent: CookiebotConsent | null =
    w.Cookiebot?.hasResponse && w.Cookiebot.consent
      ? snapshotConsent(w.Cookiebot.consent)
      : null

  const onConsentChange = (): void => {
    const consent = w.Cookiebot?.consent

    if (!consent) {
      return
    }

    const isWithdrawn =
      previousConsent !== null &&
      consentCategories.some(
        (category) => previousConsent?.[category] && !consent[category]
      )

    previousConsent = snapshotConsent(consent)

    if (isWithdrawn) {
      w.location.reload()
    }
  }

  w.addEventListener("CookiebotOnAccept", onConsentChange)
  w.addEventListener("CookiebotOnDecline", onConsentChange)
}

export type { CookieConsentCategory }

export {
  getCookiebotCbid,
  hasCookieConsent,
  renewCookieConsent,
  reloadWhenConsentWithdrawn,
}
